import React, { useState, useEffect, Fragment } from "react";
import "./input.less";
import { actions } from "react-redux-toastr";

const TeInput = ({
    required = false,
    className,
    inputClass,
    inputLabel,
    placeholder = "",
    register = null,
    name,
    type,
    errors = {},
    actions = [],
    onChange = null,
    disabled,
    maxLength = 50,
    readOnly,
    inputIcon,
    ...props
}) => {
    const label = required ? (
        <Fragment>
            {inputLabel}
            <span className={"text-danger"}>*</span>
        </Fragment>
    ) : (
            inputLabel
        );

    const onFocus = () => {
        const rootBody = document.getElementById("root");
        rootBody.classList.add("keyBoard");
    };

    const onBlur = () => {
        const rootBody = document.getElementById("root");
        rootBody.classList.remove("keyBoard");
    };

    return (
        <div
            className={`te-input ${className} ${
                actions.length > 0 ? "addons-action" : ""
                }`}
        >
            {inputLabel && <span>{label}</span>}
            <div
                className={`${inputIcon &&
                    "te-input-append-wrapper"} te-input-wrapper`}
            >
                <input
                    {...props}
                    placeholder={placeholder}
                    type={type}
                    name={name}
                    ref={register}
                    maxLength={maxLength}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    className={inputClass, 'form-control'}
                    disabled={disabled}
                    readOnly={readOnly}
                />
                {inputIcon && (
                    <span className="te-input-append">{inputIcon}</span>
                )}
                {actions && actions.length > 0 && (
                    <div className={"te-input-action"}>
                        {actions.map((item, index) => (
                            <span key={`panel-action${index}`}>{item}</span>
                        ))}
                    </div>
                )}
            </div>
            {errors.hasOwnProperty(name) && (
                <small className="error-text">
                    {errors[name].message
                        ? errors[name].message
                        : "This field is required"}
                </small>
            )}
        </div>
    );
};
export default TeInput;
